import { useResetMutation, useToggleMutation } from "../hooks";
import { MatchesQueryKeys } from "@/tanstackQuery/queries";
import {
  addSuspendedMatch,
  clearSuspendedMatches,
  deleteSuspendedMatch,
} from "@/api/matches";

export const useToggleSuspendedMatch = (userId?: number) => {
  return useToggleMutation({
    queryKey: [MatchesQueryKeys.Suspended, userId],
    addMutationFn: ({ id, providerId, feedType, password }) =>
      addSuspendedMatch(id, providerId, feedType, userId, password),
    deleteMutationFn: ({ id, providerId, feedType, password }) =>
      deleteSuspendedMatch(id, providerId, password),
    getSelectionKey: (data: { id: number }) => data.id,
    updateOptions: { exactQueryKey: true, preventRefetchOnSettled: true },
  });
};

export const useResetSuspendedMatches = (userId?: number) => {
  return useResetMutation<number[]>({
    queryKey: [MatchesQueryKeys.Suspended, userId],
    resetMutationFn: () => clearSuspendedMatches(userId),
    updateOptions: { exactQueryKey: true },
    defaultValue: [],
  });
};
